// Bhop By LasBoi: the game's own songs, made by LasBoi, in public/music/lasboi (titles are the file
// names). They play on their own station and in the mix, and need no network but the site's.

export const LASBOI_FILES = [
  'Amber_Light.mp3',
  'Architects_of_Motion.mp3',
  'Asphalt_Reflections.mp3',
  'Concrete_Cadence.mp3',
  'Concrete_Rivers.mp3',
  'Crown_the_Hurricane.mp3',
  'Electric_Rain.mp3',
  'Hydraulic_Swagger.mp3',
  'Inside_The_Moment.mp3',
  'Leather_Seat_Rebellion.mp3',
  'Locked_in_the_Cage.mp3',
  'Mechanical_Ballet.mp3',
  'Midnight_Rearview.mp3',
  'My_Own_Sweet_Pace.mp3',
  'Quiet_Kingdom.mp3',
  'Respawn_at_Midnight.mp3',
  'Shatter_The_Glass.mp3',
  'Tall_Giants.mp3',
  'Tarmac_Velocity.mp3',
  'The_Paper_Orbit.mp3',
  'Velvet_Stride.mp3',
] as const;
